import ListBlock from './list-block';
export default ListBlock.extend({
  type: 'unorderedList',
  tagName: 'ul'
});